import { logger as createLogger } from '#utils/logger'
import { internalPrintId } from './ShortcutContext'

export function dispatchCustomPrintEvent() {
  const event = new CustomEvent(internalPrintId, {
    bubbles: true,
    cancelable: true,
    detail: {
      location,
    },
  })
  window.dispatchEvent(event)
}
export const printLogger = createLogger('🖨️ Print Context:')
